import { render, staticRenderFns } from "./AddUpdateMenu.vue?vue&type=template&id=2adf9ae4&scoped=true"
import script from "./AddUpdateMenu.vue?vue&type=script&lang=js"
export * from "./AddUpdateMenu.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateMenu.vue?vue&type=style&index=0&id=2adf9ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf9ae4",
  null
  
)

export default component.exports